import * as PIXI from 'pixi.js-legacy';
import { getSprite } from '../../framework/src/modules/Sprite';
import { EASE, getTweenAsync } from '../../framework/src/modules/Tween';
import { Frames } from '../Code/Frames';

export default class BaseSymbol extends PIXI.Container { //PIXI.Sprite {
    symbolName: string;
    symbolIndex: number;

    texture: PIXI.Texture;
    sprite: PIXI.Sprite;

    fireBack: PIXI.AnimatedSprite;

    constructor(symbolName: string, index: number, blur: boolean = false) {
        let textureName = blur ? symbolName + '_blur.png' : symbolName + '.png';
        super();

        this.name = symbolName;
        this.symbolName = symbolName;
        this.symbolIndex = index;
        this.sprite = getSprite(textureName, 0, 0);
        this.addChild(this.sprite);
    }

    blur() {
        this.sprite.texture = PIXI.Texture.from(this.symbolName + '_blur.png');
    }

    unblur() {
        this.sprite.texture = PIXI.Texture.from(this.symbolName + '.png');
    }

    idle() { }

    async onStop() {
        this.sprite.visible = true;        
        this.sprite.alpha = 1;
    }

    async onWin() {
        this.sprite.visible = false;        
        this.sprite.alpha = 0;
    }

    destroy( {children = true, baseTexture = true} : {children?: boolean; baseTexture?: boolean;}={}) {
       
        // this.parent.removeChild(this);        
        // console.warn(children, baseTexture, this.symbolName);
        super.destroy({"children":children,"baseTexture":baseTexture,});
        // this.removeChildren();
    }

    createFireBack() {
        if (this.fireBack === undefined) {
            this.fireBack = new PIXI.AnimatedSprite(Frames["wildBGFire"]);
            this.fireBack.name = "fireWildBackground";
            this.fireBack.anchor.set(0.5, 0.5);           
            this.fireBack.alpha = 1;//0.5;
            this.fireBack.loop = true;
            this.fireBack.stop();
            this.fireBack.visible = false;
            this.addChild(this.fireBack, this.sprite);
        }
    }

    clearFireBack() {
        if (this.fireBack != undefined) {            
            this.fireBack.visible = false;
            this.fireBack.stop();            
            this.fireBack.destroy({ children: true , baseTexture:true});
            this.fireBack = undefined;
        } else { console.error("fire back not created !");}
    }

    async playFireBack() {
        this.fireBack.alpha = 0;
        this.fireBack.scale.set(0.5, 0.5);
        this.fireBack.visible = true;
        this.fireBack.play();
        getTweenAsync(this.fireBack.scale, { x: 1, y: 1 }, 1200, EASE.BOUN_I);
        getTweenAsync(this.fireBack, { alpha: 1 }, 900, EASE.BOUN_I);        
    }
}
